<template>
  <header
    class="flex bg-white type-scale-n3 font-medium h-10 items-center w-full flex-shrink-0 select-none sticky top-0 shadow z-10"
  >
    <div
      v-for="(header, $i) in headers"
      class="px-4"
      :key="$i"
      :style="{ width: headerWidth(header) }"
    >
      {{ header.label || header }}
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppTableHeader',

  props: {
    headers: Array
  },

  methods: {
    headerWidth(header) {
      if (!header.width) return null
      return header.width + 'px'
    }
  }
}
</script>
